import { getMenuItem } from './getMenuItem'

import type { MenuItemGroup } from '@app/types/menu'
import type { RawMenuItemGroup } from '@app/types/menu/raw'

export const getMenuItemGroup = ({ label, children }: RawMenuItemGroup): MenuItemGroup => ({
  type: 'group',
  label,
  children: children.map(rawMenuItem => getMenuItem(rawMenuItem))
})
